module.exports = __webpack_public_path__ + "img/zhga.23d9eb32.png";